import React from "react";

type ProjectDetailsEditIconProps = {
  className?: string;
};

const ProjectDetailsEditIcon: React.FC<ProjectDetailsEditIconProps> = ({
  className,
}) => (
  <svg
    className={className}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M9.333 2.667H3.333C2.597 2.667 2 3.264 2 4V12.667C2 13.403 2.597 14 3.333 14H12C12.736 14 13.333 13.403 13.333 12.667V6.667"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.333 2L14 4.667L7.333 11.333H4.667V8.667L11.333 2Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ProjectDetailsEditIcon;
